import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import { ISessionDetailProps } from '../../../../models/components/add-activity-exam-sessions';
import { IAction, IAppState } from '../../../../models/action/core';
import { connect } from 'react-redux';
import Moment from 'moment';

const T = Translator.create();
const _logger = Log.create('Exam Session Detail');
let _common: Common;

export class SessionDetail extends Component<ISessionDetailProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    componentDidUpdate(prevProps: Readonly<ISessionDetailProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if(this.props.selectedExamSession && prevProps.selectedExamSession)
        {
            if(prevProps.selectedExamSession.examSessionId !== this.props.selectedExamSession.examSessionId)
            {
                if(this.props.selectedExamSession.examSessionId)
                {
                    this.props.triggerModal(this.props.selectedExamSession.examSessionId, '_sessionProperties')
                }
            }
        }
        
    }

    public render() {
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);

        const examSessionBeginDate =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionBeginDate
                ? Moment(this.props.selectedExamSession.examSessionBeginDate.toString())
                    .format(userDateFormat)
                    .toString()
                : '';
        const examSessionBeginDateTime =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionBeginDate
                ? Moment(this.props.selectedExamSession.examSessionBeginDate.toString())
                    .format(window.appSettings.DefaultDateTimeFormat)
                    .toString()
                : '';
        const examSessionEndDate =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionEndDate
                ? Moment(this.props.selectedExamSession.examSessionEndDate.toString())
                    .format(userDateFormat)
                    .toString()
                : '';
        const examSessionEndDateTime =
            this.props.selectedExamSession && this.props.selectedExamSession.examSessionEndDate
                ? Moment(this.props.selectedExamSession.examSessionEndDate.toString())
                    .format(window.appSettings.DefaultDateTimeFormat)
                    .toString()
                : '';

        return (
            <div className="tabs-section pl-0 pt-1">
                {this.props.selectedExamSession && this.props.selectedExamSession.examSessionId ? (
                    <>
                        <div className="announcement-heading">
                            <div>
                                <div className="activity-spec d-flex align-items-center">
                                    <div style={{ width: '48px !important', height: '48px !important' }} className="spec-icon exam-time"><img src={_common.GetActivityTypeIcons('exam')} alt="" /></div>
                                    <div className='session_header'>
                                        <span>{this.props.selectedExamSession.courseName}</span>
                                        <h6>
                                            {this.props.selectedExamSession.name} ({this.props.selectedExamSession.programNames})
                                        </h6>
                                    </div>
                                </div>

                            </div>
                            <div className="session_edit_btn">
                                {/* <a data-toggle="dropdown" href="javascript:;">
                                    <img src={_common.GetDefaultIcons('dots')} alt="ActivitiesNotFound" />
                                </a> */}
                                <a
                                    className=""
                                    style={{
                                        color: '#212529',
                                        fontSize: 16
                                    }}
                                    onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionProperties')}
                                >
                                    <span className="edit_btn">
                                        <i className="material-icons">edit</i>
                                    </span>
                                    {T.t('r_fileUpload_edit')}
                                </a>
                            </div>
                        </div>
                        <div className="create-announcement assignment-modal" style={{ padding: '0em 2em' }}>
                            {/* <div className="homework-title">
                                <h2 className="mb-2">{this.props.selectedExamSession.name}</h2>
                                <p
                                    className="mb-2"
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.selectedExamSession.description
                                    }}
                                />
                            </div> */}
                            {/* <div className="d-flex justify-content-between counter-blocks">
                                <div style={{ width: '100%' }}>
                                    <div className="media" style={{ marginBottom: 15, width: '95%', cursor: 'pointer' }} onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionQuestions')}>
                                        <div className="media-body">
                                            <h4>{this.props.selectedExamSession.questionCount}</h4>
                                            <p>{T.t('r_gen_exam_session_detail_question_count')}</p>
                                        </div>
                                    </div>
                                    <div className="media" style={{ width: '95%', cursor: 'pointer' }} onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionProperties')}>
                                        <div className="media-body">
                                            <div className="d-flex justify-content-between" style={{ flexDirection: 'column' }}>
                                                <h4>{examSessionBeginDate}</h4>
                                                <h4>{examSessionBeginDateTime}</h4>
                                            </div>
                                            <p>{T.t('r_gen_exam_session_detail_begin_date')}</p>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <div className="media" style={{ marginBottom: 15, float: 'right', width: '95%', cursor: 'pointer' }} onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionStudents')}>
                                        <div className="media-body">
                                            <div className="d-flex justify-content-between">
                                                <h4>{this.props.selectedExamSession.studentCount}</h4>
                                            </div>
                                            <p>{T.t('r_gen_exam_session_detail_student_count')}</p>
                                        </div>
                                    </div>
                                    <div className="media" style={{ float: 'right', width: '95%', cursor: 'pointer' }} onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionProperties')}>
                                        <div className="media-body">
                                            <div className="d-flex justify-content-between" style={{ flexDirection: 'column' }}>
                                                <h4>{examSessionEndDate}</h4>
                                                <h4>{examSessionEndDateTime}</h4>
                                            </div>
                                            <p>{T.t('r_gen_exam_session_detail_end_date')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-md-6 col-12">
                                    <div className="media session_detail_card" onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionAddQuestion')}>
                                        <div className="media-body d-flex justify-content-start align-items-center">
                                            <div style={{ width: '48px !important', height: '48px !important' }} className="session_detail_card_icon question_icon"><img className='img-fluid' src={_common.GetDefaultIcons('questionmark')} alt="" /></div>
                                            <div className='d-flex flex-column align-items-start'>
                                                <p style={{ margin: 'auto 0' }}>{T.t('r_add_exam_question_count')}</p>
                                                <h4>{this.props.selectedExamSession.questionCount}</h4>
                                            </div>
                                        </div>
                                        <div className="session_detail_add_btn">
                                            <span className="add_btn">
                                                <i className="material-icons">add</i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12">
                                    <div className="media session_detail_card" onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionStudents')}>
                                        <div className="media-body d-flex justify-content-start align-items-center">
                                            <div style={{ width: '48px !important', height: '48px !important' }} className="session_detail_card_icon person_icon"><img className='img-fluid' src={_common.GetDefaultIcons('fillerpersonlight')} alt="" /></div>
                                            <div className='d-flex flex-column align-items-start'>
                                                <p style={{ margin: 'auto 0' }}>{T.t('r_gen_exam_session_detail_student_count')}</p>
                                                <h4>{this.props.selectedExamSession.studentCount}</h4>
                                            </div>
                                        </div>
                                        <div className="session_detail_add_btn">
                                            <span className="add_btn">
                                                <i className="material-icons">add</i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="media session_detail_card" onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionProperties')}>


                                        <div className="media-body d-flex justify-content-start align-items-center">
                                            <div style={{ width: '48px !important', height: '48px !important' }} className="session_detail_card_icon start_icon"><img className='img-fluid' src={_common.GetDefaultIcons('hourstartlight')} alt="" /></div>
                                            <div className='d-flex flex-column align-items-start'>
                                                <p style={{ margin: 'auto 0' }}>{T.t('r_activity_begin_date')}</p>
                                                <h4>{examSessionBeginDate} - {examSessionBeginDateTime}</h4>
                                            </div>
                                        </div>
                                        <div className="session_detail_add_btn">
                                            <span className="add_btn">
                                                <i className="material-icons">edit</i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="media session_detail_card" onClick={this.props.triggerModal.bind(this, this.props.selectedExamSession.examSessionId, '_sessionProperties')}>

                                        <div className="media-body d-flex justify-content-start align-items-center">
                                            <div style={{ width: '48px !important', height: '48px !important' }} className="session_detail_card_icon end_icon"><img className='img-fluid' src={_common.GetDefaultIcons('hoursendlight')} alt="" /></div>
                                            <div className='d-flex flex-column align-items-start'>
                                                <p style={{ margin: 'auto 0' }}>{T.t('r_activity_due_date')}</p>
                                                <h4>{examSessionEndDate} - {examSessionEndDateTime}</h4>
                                            </div>
                                        </div>
                                        <div className="session_detail_add_btn">
                                            <span className="add_btn">
                                                <i className="material-icons">edit</i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="create-announcement text-center assignment-modal">
                        <div className="d-inline-block">
                            <img src={_common.GetDefaultImages('_activitiesnotfound')} alt="ActivitiesNotFound" />
                            <h5 className="mt-4">{T.t('r_gen_exam_session_not_found')}</h5>
                            <p>{T.t('r_gen_exam_session_not_found_info')}</p>
                            <button className="btn btn-outline" type="button">
                                {T.t('r_gen_exam_session_add')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISessionDetailProps): ISessionDetailProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISessionDetailProps = Object.assign({}, ownProps, {
        selectedExamSession: state.examSession.selectedSession,
        userPreferences: state.profile.userPreferences.preferences
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.examSession.selectedSession === prev.examSession.selectedSession &&
        next.profile.userPreferences === prev.profile.userPreferences;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CSessionDetail = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(SessionDetail);

export default CSessionDetail;
